import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiMail, FiLock, FiArrowRight } from 'react-icons/fi';
import { useAuth } from './AuthContext';
import { NoSubscriptionError } from '../../services/authService';
import { ROUTES } from '../../app/routes';
import { getDefaultPage } from '../../services/userPreferencesService';
import { markThinkTankNoticePending } from '../notices/ThinkTankNotice';
import logo from '../../assets/images/M_Multicolor.svg';
import '../../styles/AuthPages.css';
const LoginPage: React.FC = () => {
    const { login, isLoading, error, clearError } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [fetchingDefault, setFetchingDefault] = useState(false);
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        localStorage.setItem('loginPending', '1');
        try {
            await login(email, password);
            markThinkTankNoticePending();
            setFetchingDefault(true);
            const redirectTarget = sessionStorage.getItem('redirectAfterLogin');
            if (redirectTarget) {
                sessionStorage.removeItem('redirectAfterLogin');
                localStorage.removeItem('loginPending');
                navigate(redirectTarget, { replace: true });
                return;
            }
            const defaultPath = await getDefaultPage();
            localStorage.removeItem('loginPending');
            localStorage.setItem('postLoginDefaultPath', defaultPath || '');
            navigate(defaultPath || ROUTES.START, { replace: true });
        }
        catch (err) {
            localStorage.removeItem('loginPending');
            setFetchingDefault(false);
            if (err instanceof NoSubscriptionError) {
                navigate(ROUTES.REQUEST_EARLY_ACCESS, { replace: true, state: err.data });
            }
        }
    };
    return (<div className="auth-page">
      <div className="auth-page__glow"/>
      <motion.div className="auth-card-signin glass-elevated" initial={{ opacity: 0, y: 30, scale: 0.95 }} animate={{ opacity: 1, y: 0, scale: 1 }} transition={{ duration: 0.5, ease: [0.34, 1.56, 0.64, 1] }}>
        <div className="auth-card__header">
          <img src={logo} alt="Insurance Agency AI" className="auth-card__logo"/>
          <h1 className="auth-card__title">Welcome Back</h1>
          <p className="auth-card__subtitle">Sign in to your workspace</p>
        </div>

        <form className="auth-card__form" onSubmit={handleSubmit}>
          <div className="auth-card__field">
            <label className="auth-card__label">Email</label>
           
            <div className="auth-card__input-wrap">
              <FiMail className="auth-card__input-icon" size={16}/>
              <input type="email" className="glass-input auth-card__input" placeholder="you@agency.com" value={email} onChange={(e) => { setEmail(e.target.value); clearError(); }} required autoFocus/>
            </div>
          </div>

          <div className="auth-card__field">
            <label className="auth-card__label">Password</label>
            <div className="auth-card__input-wrap">
              <FiLock className="auth-card__input-icon" size={16}/>
              <input type="password" className="glass-input auth-card__input" placeholder="Enter your password" value={password} onChange={(e) => { setPassword(e.target.value); clearError(); }} required/>
            </div>
          </div>

          {error && (<motion.p className="auth-card__error" initial={{ opacity: 0, y: -5 }} animate={{ opacity: 1, y: 0 }}>
              {error}
            </motion.p>)}

          <motion.button type="submit" className="glass-btn glass-btn-primary glass-btn-primary--purple auth-card__submit" disabled={isLoading || fetchingDefault} whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
            {(isLoading || fetchingDefault) ? (<span className="auth-card__loader"/>) : (<>
                Sign In <FiArrowRight size={16}/>
              </>)}
          </motion.button>
        </form>

        <div className="auth-card__divider">
          <span>or</span>
        </div>

        <Link to={ROUTES.CHAT} className="auth-card__guest-link">
          Continue as Guest
        </Link>

        
      </motion.div>
    </div>);
};
export default LoginPage;
